import m from 'mithril'
import { initMithrilComponent } from '@client-shared/utils/mithril'

const WarningTriangleIcon = initMithrilComponent()
WarningTriangleIcon.view = () =>
	m(
		'svg',
		Object.assign({
			width: 16,
			height: 16,
			viewBox: '0 0 16 16',
			fill: 'none',
			'aria-hidden': 'true',
			style: 'width: var(--icon-width, 16px); height: var(--icon-height, 16px);',
		}),
		m(
			'g',
			{ 'clip-path': 'url(#clip0_10039_1760)' },
			m(
				'g',
				{ 'clip-path': 'url(#clip1_10039_1760)' },
				m('path', {
					d: 'M14.2096 12.1981L9.00637 2.62328C8.90279 2.43246 8.74963 2.27313 8.56305 2.16211C8.37646 2.05108 8.16336 1.99248 7.94625 1.99248C7.72913 1.99248 7.51603 2.05108 7.32944 2.16211C7.14286 2.27313 6.9897 2.43246 6.88612 2.62328L1.68664 12.1981C1.58382 12.3822 1.53107 12.5901 1.53363 12.8009C1.53619 13.0118 1.59399 13.2183 1.70125 13.3998C1.80851 13.5814 1.9615 13.7316 2.14495 13.8356C2.3284 13.9396 2.5359 13.9937 2.74677 13.9925H13.1495C13.3582 13.9922 13.5633 13.9379 13.7447 13.8347C13.9261 13.7315 14.0777 13.5829 14.1845 13.4036C14.2913 13.2243 14.3498 13.0203 14.3542 12.8117C14.3586 12.603 14.3088 12.3968 14.2096 12.2131V12.1981ZM7.46675 5.00201C7.46675 4.86292 7.52201 4.72952 7.62036 4.63117C7.71871 4.53282 7.85211 4.47756 7.9912 4.47756C8.13029 4.47756 8.26368 4.53282 8.36203 4.63117C8.46039 4.72952 8.51564 4.86292 8.51564 5.00201V9.49723C8.51564 9.63632 8.46039 9.76972 8.36203 9.86807C8.26368 9.96642 8.13029 10.0217 7.9912 10.0217C7.85211 10.0217 7.71871 9.96642 7.62036 9.86807C7.52201 9.76972 7.46675 9.63632 7.46675 9.49723V5.00201ZM7.9912 12.4379C7.85784 12.4379 7.72747 12.3983 7.61659 12.3242C7.5057 12.2501 7.41928 12.1448 7.36824 12.0216C7.31721 11.8984 7.30385 11.7628 7.32987 11.632C7.35589 11.5012 7.42011 11.3811 7.51441 11.2868C7.60871 11.1925 7.72885 11.1283 7.85965 11.1022C7.99045 11.0762 8.12603 11.0896 8.24923 11.1406C8.37244 11.1917 8.47775 11.2781 8.55184 11.389C8.62594 11.4998 8.66548 11.6302 8.66548 11.7636C8.66548 11.8521 8.64804 11.9398 8.61415 12.0216C8.58027 12.1034 8.5306 12.1778 8.46799 12.2404C8.40538 12.303 8.33104 12.3526 8.24923 12.3865C8.16743 12.4204 8.07975 12.4379 7.9912 12.4379Z',
					fill: 'var(--icon-color, currentColor)',
				}),
			),
			m(
				'defs',
				m('clipPath', { id: 'clip0_10039_1760' }, m('rect', { width: 16, height: 16, fill: 'white' })),
				m('clipPath', { id: 'clip1_10039_1760' }, m('rect', { width: 16, height: 16, fill: 'white' })),
			),
		),
	)
export default WarningTriangleIcon
